import { useState } from 'react';

import { Button, Stack, Text } from '@mantine/core';

import { IS_TOUCH_LOCAL_STORAGE_KEY, TouchDeviceType } from 'helpers/isTouchDevice';

import { SimpleButton } from 'components/buttons/SimpleButton';
import { SimpleButtonGroup } from 'components/buttons/SimpleButtonGroup';
import { LocalStorageService } from 'services/LocalStorageService';
import { RouterService } from 'services/RouterService';

const DeviceTypeModal = () => {
    const localStorageValue = LocalStorageService.get(IS_TOUCH_LOCAL_STORAGE_KEY);
    const [selected, setSelected] = useState<TouchDeviceType | null>(localStorageValue);

    const handleChange = (deviceType: TouchDeviceType | null) => {
        setSelected(deviceType);
    };

    const handleSave = () => {
        if (selected) {
            LocalStorageService.store(IS_TOUCH_LOCAL_STORAGE_KEY, selected);
        } else {
            LocalStorageService.clear(IS_TOUCH_LOCAL_STORAGE_KEY);
        }

        RouterService.reload();
    };

    return (
        <Stack gap="xs" align="center">
            <Text fw={500}>Set device type (for demo purposes)</Text>
            <SimpleButtonGroup>
                {Object.values(TouchDeviceType).map((option) => (
                    <SimpleButton
                        key={option}
                        onClick={() => {
                            handleChange(option as TouchDeviceType);
                        }}
                        bg={selected === option ? 'white' : 'gray.1'}
                    >
                        {option}
                    </SimpleButton>
                ))}
                <SimpleButton
                    onClick={() => {
                        handleChange(null);
                    }}
                    bg={selected === null ? 'white' : 'gray.1'}
                >
                    None set
                </SimpleButton>
            </SimpleButtonGroup>

            <Button size="xs" onClick={handleSave}>
                Save my preference
            </Button>
        </Stack>
    );
};

export { DeviceTypeModal };
